(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pm-partner-collage"] && !Shopify.designMode) return;
  try {
    
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const pending = new Set();
  const running = new Map();
  const enabled = () => !!document.querySelector('.pm-partner-collage[data-motion="true"]') && !preference.matches;
  const play = (element, delay = 0, image = false) => {
    if (!enabled() || !element.animate) return;
    const frames = image
      ? [{transform:'scale(1.08)'},{transform:'scale(1)'}]
      : [{opacity:0,transform:'translateY(30px) scale(.975)'},{opacity:1,transform:'translateY(0) scale(1)'}];
    const animation = element.animate(frames, {
      duration:image ? 1300 : 780, delay,
      easing:'cubic-bezier(.16,1,.3,1)', fill:'backwards'
    });
    running.set(animation, element);
    animation.finished.then(() => running.delete(animation), () => running.delete(animation));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || !enabled()) return;
      const element = entry.target;
      observer.unobserve(element);
      pending.delete(element);
      seen.add(element);
      const peers = [...element.parentElement.children];
      const grouped = element.parentElement.matches('.pm-partner-values__grid,.pm-partner-brand__grid,.pm-partner-social__grid,.pm-partner-collage__intro');
      play(element, grouped ? Math.max(0, peers.indexOf(element) % 3) * 110 : 0);
      if (element.matches('.pm-partner-brand__tile,.pm-partner-about__image')) {
        const image = element.querySelector(':scope > img');
        if (image) play(image, 0, true);
      }
    });
  }, {threshold:.2}) : null;
  const selector = '.pm-partner-collage__intro>p,.pm-partner-collage__intro>h1,.pm-partner-collage__buttons,.pm-partner-values__card,.pm-partner-introduction__inner,.pm-partner-models header,.pm-partner-models__tabs,.pm-partner-models__deck,.pm-partner-brand header,.pm-partner-brand__tile,.pm-partner-about__image,.pm-partner-compare header,.pm-partner-compare__pictures,.pm-partner-compare__table,.pm-partner-social header,.pm-partner-social__item,.pm-partner-social__action';
  const init = () => {
    if (!enabled() || !observer) return;
    document.querySelectorAll(selector).forEach(element => {
      if (seen.has(element) || pending.has(element)) return;
      pending.add(element);
      observer.observe(element);
    });
  };
  const stop = () => {
    running.forEach((element, animation) => animation.cancel());
    running.clear();
    observer?.disconnect();
    pending.clear();
  };
  preference.addEventListener('change', () => { stop(); init(); });
  document.addEventListener('shopify:section:load', () => { stop(); init(); });
  document.addEventListener('shopify:section:unload', event => {
    pending.forEach(element => {
      if (event.target.contains(element)) { observer?.unobserve(element); pending.delete(element); }
    });
    running.forEach((element, animation) => {
      if (event.target.contains(element)) animation.cancel();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-shop-by-shape"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pm-shape-slider')) {
    customElements.define(
      'pm-shape-slider',
      class PMShapeSlider extends HTMLElement {
        connectedCallback() {
          if (this.dataset.pmShapeReady === 'true') return;

          this.dataset.pmShapeReady = 'true';
          this.track = this.querySelector('[data-pm-shape-track]');
          this.previousButton = this.querySelector('[data-pm-shape-direction="previous"]');
          this.nextButton = this.querySelector('[data-pm-shape-direction="next"]');

          if (!this.track || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', () => this.move(-1));
          this.nextButton.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.requestUpdate(), { passive: true });

          this.resizeObserver = new ResizeObserver(() => this.updateButtons());
          this.resizeObserver.observe(this.track);
          this.updateButtons();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        move(direction) {
          const card = this.track.querySelector('.pm-shop-by-shape__card');
          if (!card) return;

          const styles = getComputedStyle(this.track);
          const gap = parseFloat(styles.columnGap) || 0;
          const distance = card.getBoundingClientRect().width + gap;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.track.scrollBy({
            left: direction * distance,
            behavior: reduceMotion ? 'auto' : 'smooth'
          });
        }

        requestUpdate() {
          if (this.updateFrame) return;

          this.updateFrame = requestAnimationFrame(() => {
            this.updateFrame = null;
            this.updateButtons();
          });
        }

        updateButtons() {
          const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
          this.previousButton.disabled = this.track.scrollLeft <= 1;
          this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
